import { PlacementPage } from "components/feature";
import { SectionHeader } from "components/layout";
import { InlineBanner } from "components/ui/inline-banner";
import {
    useGetPendingIncomingClientTransfersQuery,
    useGetPendingOutgoingClientTransfersQuery,
} from "generated/graphql";
import * as React from "react";
import { useCallback } from "react";
import { useRegionId } from "store/selectors/hooks";
import { QueryRenderer } from "../show-client/community-comparison/query-renderer";
import { IncomingTransferCard } from "./incoming-transfer-card";
import { OutgoingTransferCard } from "./outgoing-transfer-card";

export const ClientTransfers: React.FunctionComponent = () => {
    const regionId = useRegionId();
    const incoming = useGetPendingIncomingClientTransfersQuery({ regionId });
    const outgoing = useGetPendingOutgoingClientTransfersQuery({ regionId });

    const onCancelled = useCallback(async () => {
        await outgoing.refetch();
    }, [outgoing]);

    const onRejected = useCallback(async () => {
        await incoming.refetch();
    }, [incoming]);

    return (
        <PlacementPage>
            <div>
                <div className="col main-body full-width min-h-screen bg-white px-4 py-2">
                    <div className="space-y-4 lg:space-y-0 lg:flex lg:space-x-4">
                        <div className="flex-1">
                            <SectionHeader title="Incoming transfers" />
                            <QueryRenderer query={incoming} name="incoming">
                                {data =>
                                    data.getPendingIncomingClientTransfers.length > 0 ? (
                                        <ul className="space-y-2 md:space-y-4">
                                            {data.getPendingIncomingClientTransfers.map(
                                                transfer => (
                                                    <li key={transfer.id}>
                                                        <IncomingTransferCard
                                                            clientTransferRequest={
                                                                transfer
                                                            }
                                                            onRejected={onRejected}
                                                        />
                                                    </li>
                                                ),
                                            )}
                                        </ul>
                                    ) : (
                                        <InlineBanner type="info">
                                            No incoming transfers
                                        </InlineBanner>
                                    )
                                }
                            </QueryRenderer>
                        </div>
                        <div className="flex-1">
                            <SectionHeader title="Outgoing transfers" />
                            <QueryRenderer query={outgoing} name="outgoing">
                                {data =>
                                    data.getPendingOutgoingClientTransfers.length > 0 ? (
                                        <ul className="space-y-2 md:space-y-4">
                                            {data.getPendingOutgoingClientTransfers.map(
                                                transfer => (
                                                    <li key={transfer.id}>
                                                        <OutgoingTransferCard
                                                            clientTransferRequest={
                                                                transfer
                                                            }
                                                            onCancelled={onCancelled}
                                                        />
                                                    </li>
                                                ),
                                            )}
                                        </ul>
                                    ) : (
                                        <InlineBanner type="info">
                                            No outgoing transfers
                                        </InlineBanner>
                                    )
                                }
                            </QueryRenderer>
                        </div>
                    </div>
                </div>
            </div>
        </PlacementPage>
    );
};
